const local_type = {
    'AGENCE': 'local_agence',
    'PLATEFORME': 'local_plateforme',
};

export default local_type;
